/**
 * Select now lives in the shared design system, @atomic/ui-kit — shared with
 * chomps. Thin re-export shim; existing imports keep working unchanged.
 */
export {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "@atomic/ui-kit"
